// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1dMsg","question":"styles_question__bGkgP","inputVisibleButton":"styles_inputVisibleButton__1VLod","note":"styles_note__24Ft6"};